import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#fff",
  "stroke-linecap": "round",
  "stroke-opacity": ".9",
  "stroke-width": "2",
  d: "m18 4-4.658-2.33a3 3 0 0 0-2.684 0l-7 3.5A3 3 0 0 0 2 7.855v7.674a4 4 0 0 0 2.211 3.578l6.447 3.223a3 3 0 0 0 2.684 0l6.447-3.223A4 4 0 0 0 22 15.528v-7.66a1 1 0 0 0-1.555-.832L19 8"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#CF0",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8.5 10.5 12 13l3.5-2.5"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }